import _omit from 'lodash/omit'
import _startCase from 'lodash/startCase'
import FilterDropdownWrapper from 'common/FilterDropdownWrapper'
import { MobileFilterModalContext } from 'context/ProviderSearch/MobileFilterModalProvider'
import { useState, useMemo, useContext } from 'react'
import DropdownMenu from 'common/SingleSelectDropdown'
import { useRouter } from 'next/router'
import { modifyURLQuery } from 'utils/common'
import { sortFilterOptions } from 'app/ProviderSearch/constants'
import useBreakpoint from 'hooks/useBreakPoint'
import styles from './index.module.scss'
import { ProviderFilterTypes } from 'dataSource/ProviderSearch'

type SortFilterProps = {
  className?: string
}

const SortFilter: React.FC<SortFilterProps> = ({ className = '' }) => {
  const [showDropdown, setShowDropdown] = useState<boolean>(false)
  const router = useRouter()
  const { openMobileFilter } = useContext(MobileFilterModalContext)
  const { isMobileScreen, isLargeSize } = useBreakpoint()
  const { query } = router

  const onOptionSelected = (option: SelectItem): void => {
    const { value } = option

    modifyURLQuery(router, {
      orderBy: value,
    })
    setShowDropdown(false)
  }

  const onClearSort = (): void => {
    const formattedQuery = _omit(query, ['orderBy'])
    modifyURLQuery(router, formattedQuery, true)

    if (showDropdown) {
      setShowDropdown(false)
    }
  }

  const filterValue = useMemo(
    () => sortFilterOptions.find((option) => option.value === query?.orderBy),
    [query?.orderBy]
  )

  return (
    <FilterDropdownWrapper
      placeholder="Sort by"
      value={_startCase(filterValue?.value ?? '')}
      onPillClick={(shouldShow) => {
        if (isMobileScreen || isLargeSize) {
          openMobileFilter(ProviderFilterTypes.ORDER_BY)
        } else {
          setShowDropdown(shouldShow)
        }
      }}
      showDropdown={showDropdown}
      onClearValue={onClearSort}
      className={className}
    >
      {showDropdown && (
        <DropdownMenu
          options={sortFilterOptions}
          onSelectItem={onOptionSelected}
          className={styles.sort_filter_dropdown_container}
        />
      )}
    </FilterDropdownWrapper>
  )
}

export default SortFilter
